var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100.83 50.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0071ce;}.cls-2{fill:#fff;}.cls-3{fill:#13110c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "100.83 0 0 17.7 5.79 50.02 100.83 33.2 100.83 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "6.24 36.34 10 18.65 20.28 18.65 19.16 22.38 13.75 22.38 13.12 25.35 17.54 25.35 16.77 28.96 12.36 28.96 11.6 32.56 17.66 32.56 16.85 36.34 6.24 36.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.29,18.45l4.59-.76A13.52,13.52,0,0,1,25.5,21l-2.08,9.72c-.48,2.31-.53,2.92.46,2.92a1.74,1.74,0,0,0,.48-.07l.13,2.74a9.51,9.51,0,0,1-2.94.4c-3.74,0-3.41-1.93-2.85-4.54l1.91-8.93a18.67,18.67,0,0,0,.68-4.75"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37,27.28,36,32a2.37,2.37,0,0,0,.51,2l-3.58,2.87a2.38,2.38,0,0,1-1-1.55,5,5,0,0,1-3.4,1.45c-2.66,0-3.78-1.68-3.78-4.47a10.88,10.88,0,0,1,2.82-7.38,6.83,6.83,0,0,1,5.4-2,14.08,14.08,0,0,1,5,.78,24.24,24.24,0,0,0-1,3.58m-4.69-1.09a1.87,1.87,0,0,0-1.6.71c-.94,1.09-1.5,3.66-1.5,5.28,0,.89.25,1.27.86,1.27a2.4,2.4,0,0,0,1.55-1.34l1.22-5.74a.87.87,0,0,0-.53-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M46.93,22.92c3.27,0,3.6,1.85,3.2,3.75l-2.06,9.67H43.66L45.43,28c.23-1,.1-1.47-.63-1.47A2.13,2.13,0,0,0,43,27.71l-1.85,8.63H36.7l1.75-8.25a11.88,11.88,0,0,0,.36-4.44l3.91-.73A8.11,8.11,0,0,1,43,24.34a6.22,6.22,0,0,1,4-1.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.52,36.67c-3.66,0-5.43-2.33-4.49-6.75s3.63-7,7.48-7a4.88,4.88,0,0,1,4,1.55l-2.59,2.66a2.22,2.22,0,0,0-1.65-1c-1,0-1.77.81-2.33,3.47s-.51,3.76.76,3.76a3.93,3.93,0,0,0,2.64-1.17l1.32,2.59a7.85,7.85,0,0,1-5.1,1.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M72.52,27.56c0,3.43-1.9,9.11-8,9.11-3.09,0-4.84-1.7-4.84-4.72,0-3.37,1.83-9,8-9,2.74,0,4.84,1.34,4.84,4.64m-8.24,4.82c0,.82.28,1.2,1,1.2,1.82,0,2.58-5.51,2.58-6.4s-.33-1.19-1-1.19c-1.82,0-2.58,5.48-2.58,6.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "91.61 38.72 93.11 38.72 93.11 42.73 93.79 42.73 93.79 38.72 95.29 38.72 95.29 38.1 91.61 38.1 91.61 38.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "96.96 42.73 96.96 38.55 96.99 38.55 98.27 42.73 98.81 42.73 100.12 38.55 100.15 38.55 100.15 42.73 100.83 42.73 100.83 38.1 99.61 38.1 98.59 41.54 98.56 41.54 97.47 38.1 96.28 38.1 96.28 42.73 96.96 42.73"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBlue);
export default __webpack_public_path__ + "static/media/logo_blue.ddca208023ae8de28d4e02bc226c74be.svg";
export { ForwardRef as ReactComponent };